export default __webpack_public_path__ + "media/images/logo-5be4e04b9d898a4674e391e7df7a0c5e.svg";